import { Image } from '@findy-code/yuffie/ui/image';
import Link from 'next/link';
import type { ComponentProps } from 'react';

import styles from './findy-logo-link.component.module.scss';

type Props = {
  align?: 'left' | 'center';
  to?: '/home' | '/';
} & ComponentProps<'div'>;

export const FindyLogoLink = ({
  align = 'left',
  to = '/home',
  className,
  ...rest
}: Props) => {
  return (
    <div
      className={[styles.wrapper, className].filter(Boolean).join(' ')}
      data-align={align}
      {...rest}
    >
      <Link href={to}>
        <Image
          alt="Findy"
          aria-label="Findy"
          fullWidth={false}
          height={25}
          src="/images/logo.svg"
          width={86}
        />
      </Link>
    </div>
  );
};
